import { useState } from 'react'

import { meetingApi } from '../api'

export const useResendFiles = () => {
  const [isResending, setIsResending] = useState(false)

  const resendFiles = async (meetingId: string, email?: string) => {
    setIsResending(true)

    try {
      const ok = await meetingApi.resendFiles(meetingId, email)
      return ok
    } catch (error) {
      console.error('Failed to resend files', error)
    } finally {
      setIsResending(false)
    }
  }

  return { isResending, resendFiles }
}

export default useResendFiles
